export default __webpack_public_path__ + "static/media/traffic.98bab97b.svg";